export default __webpack_public_path__ + "static/media/mtn.8f77a285.jpg";